import React from "react";
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query'

import { useDebounce } from 'use-debounce';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 4
    },
  },
})
import SnapshotApp from './components/crown-pastoral-land-snapshot'



const App = ({ settings }) => {


  return (
    <QueryClientProvider client={queryClient}>
      <SnapshotApp {...settings} />
    </QueryClientProvider>
  )
}


const blocks = document.querySelectorAll('.linz-map-snapshot__cpl');

if(blocks) {
  blocks.forEach(block => {

    //const bid = block.getAttribute('id').replace('block-','');
    //const app = block.querySelector('.place-name-consulatation-map__attach');

    const settings = drupalSettings.linz_map_snapshot_cpl;

    const root = createRoot(block)
    root.render(<App settings={settings} />)

  })
}

